import axios from 'axios';
import {setupCache} from 'axios-cache-interceptor';
import {stringifyQuery} from '@di-shared/utils/queryStringUtils';
import {ApiErrorResponse} from '@di-shared/api/di/type';

export interface RequestHeaderInterceptor {
  (): Promise<Record<string, string>>;
}

const cciHttpInstance = axios.create({
  // setCciBaseUrl 함수를 통해 설정
  baseURL: '',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  allowAbsoluteUrls: false,
  withCredentials: false,
  paramsSerializer: {
    serialize: (params) => stringifyQuery(params),
  },
});

let requestHeaderInterceptor: RequestHeaderInterceptor = () => Promise.resolve({});

cciHttpInstance.interceptors.request.use(
  async (config) => {
    const headers = await requestHeaderInterceptor();
    Object.entries(headers).forEach(([key, value]) => {
      if (!config.headers[key]) {
        config.headers[key] = value;
      }
    });
    return config;
  },
  (error) => Promise.reject(error)
);

cciHttpInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export function setCciBaseUrl(baseUrl: string) {
  cciHttpInstance.defaults.baseURL = baseUrl;
}

export function setCciKrApiRequestHeaderInterceptor(interceptor: RequestHeaderInterceptor) {
  requestHeaderInterceptor = interceptor;
}
export function setCciEuApiRequestHeaderInterceptor(interceptor: RequestHeaderInterceptor) {
  requestHeaderInterceptor = interceptor;
}
export function setCciNaApiRequestHeaderInterceptor(interceptor: RequestHeaderInterceptor) {
  requestHeaderInterceptor = interceptor;
}

export function isApiErrorResponse(error: unknown): error is ApiErrorResponse {
  return error !== null && typeof error === 'object' && 'code' in error && 'message' in error && 'errors' in error;
}

// default Cache Time : 5 * 60 * 1000
const cciAxios = setupCache(cciHttpInstance, {
  methods: ['get', 'post'],
});
export default cciAxios;
